import * as React from "react";
const SvgFiRrSkull = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-skull_svg__a)">
      <path
        fill="#062147"
        d="M12.749.024c-3.079-.2-6.01.841-8.258 2.944A11.04 11.04 0 0 0 1 11v4a5.01 5.01 0 0 0 4.018 4.903A4.506 4.506 0 0 0 9.5 24h5a4.506 4.506 0 0 0 4.482-4.097A5.01 5.01 0 0 0 23 15v-3.647C23 5.384 18.497.408 12.749.024M21 15c0 1.654-1.346 3-3 3a1 1 0 0 0-1 1v.5c0 1.38-1.122 2.5-2.5 2.5h-5A2.503 2.503 0 0 1 7 19.5V19a1 1 0 0 0-1-1c-1.654 0-3-1.346-3-3v-4a9.03 9.03 0 0 1 2.856-6.57 8.91 8.91 0 0 1 6.759-2.409c4.701.313 8.384 4.413 8.384 9.332zm-11-4a2 2 0 1 1-3.999.001 2 2 0 0 1 3.999 0m8 0a2 2 0 1 1-3.999.001 2 2 0 0 1 3.999 0m-4 5.997c0 1.105-.895 1-2 1s-2 .105-2-1 .895-3 2-3 2 1.895 2 3"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-skull_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSkull;
